import React from 'react';
import { Form, Col, Row } from '../../components/ui-kit';

const DefaultFormGroup = props => {
  const errors = props.errors || [];
  // const validationState = errors.length > 0 ? 'error' : null;
  const errorMessage = errors.join(', ');

  return (
    <Form.Group as={Row} className={'mb-3'}>
      <Form.Label column sm={3}>
        {props.label} {props.required && '*'}
      </Form.Label>
      <Col sm={6}>
        {props.children}
        {errors.length > 0 && <Form.Text className="text-danger">{errorMessage}</Form.Text>}
      </Col>
    </Form.Group>
  );
};

export default DefaultFormGroup;
